import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	segmentationMessageRestricted: {
		id: 'custom-sites-extensions.link-cards.link-cards-content.segmentation-message.restricted',
		defaultMessage: 'Relevant to you',
		description: 'The content is only viewable to the user and not to everyone',
	},
});
